import { apiRoutes, post } from './apiRoutes'
import * as schema from './schema/appGatewayServer'
import i18n from '@/i18n'
import { getViewerToken, getWebappToken } from '@/utils/token'

// プロキシ経由のAPI用ヘッダー（destinationヘッダーはサーバー側で付与するため不要）
const defaultHeaders: { [k: string]: string | undefined } = {
  Authorization: undefined as string | undefined,
  'Accept-Language': i18n.locale,
  'X-VLIVE-CLIENT-TYPE': 'webapp',
}

const tree = {
  age_verification: {
    status: post<
      schema.ApiAgeVerificationStatusParam,
      schema.ApiAgeVerificationStatusPayload
    >(),
    start: post<
      schema.ApiAgeVerificationStartParam,
      schema.ApiAgeVerificationStartPayload
    >(),
  },
}

// 同一オリジンのプロキシエンドポイントを使用
const routePath = apiRoutes('/api/v1', defaultHeaders)(tree)

export default routePath

// 実行時に各種ヘッダをセットするラッパー
export const apiProxy = () => {
  const viewerToken = getViewerToken()
  const webappToken = getWebappToken()

  if (viewerToken) {
    defaultHeaders.Authorization = `Bearer ${viewerToken}`
  } else if (webappToken) {
    defaultHeaders.Authorization = `Bearer ${webappToken}`
  }

  return routePath
}
